import { SelfAssessMessage, VATSTATUS } from '@atlassian/cssxp-types-billing';
import React from 'react';

export const TaxId = ({
  taxId,
  label,
  vatStatus,
}: {
  taxId?: string | null;
  label?: string | null;
  vatStatus?: string | null;
}) => (
  <div>
    <label>{label ?? 'Tax ID'}</label>
    <div data-testid="tax-id">{taxId ?? 'No'}</div>
    {vatStatus
      ? vatStatus === VATSTATUS.no_self_assess_and_pay
        ? SelfAssessMessage.NOT_REQUIRED
        : SelfAssessMessage.REQUIRED
      : null}
  </div>
);
